<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <h5 v-if="formType == 'edit'">
              Editar {{ equipment }} {{ oldName }}
            </h5>
            <h5 v-else>Adicionar {{ equipment }}</h5>
          </div>
          <div class="pl-3 pr-3">
            <b-form-text id="input-name">Nome *</b-form-text>
            <!-- <b-form-text v-show="form.NAME">Nome *</b-form-text> -->
            <b-form-input
              v-model="form.NAME"
              :formatter="notEmpty"
              placeholder="Informe o nome"
              maxlength="24"
              size="sm"
              id="input-name"
              aria-describedby="nameInput nameInputLiveFeedback"
              :state="nameState && notRepeatedName"
            />
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>

            <b-form-text  id="input-maker">Fabricante</b-form-text>
            <!-- <b-form-text v-show="form.MAKER">Fabricante</b-form-text> -->
            <b-form-input
              v-model="form.MAKER"
              placeholder="Informe o fabricante"
              :formatter="notEmpty"
              maxlength="24"
              size="sm"
              id="input-maker"
              aria-describedby="makerInputLiveFeedback"
              state="valid"
            />

            <b-form-text id="input-cte">L/Pulso *</b-form-text>
            <!-- <b-form-text v-show="form.CTE">L/Pulso *</b-form-text> -->
            <b-form-input
              v-model="form.CTE"
              :formatter="notEmpty"
              :state="CTEstate"
              size="sm"
              aria-describedby="cteInputLiveFeedback"
              placeholder="L/Pulso *"
              id="input-cte"
            >
            </b-form-input>
            <b-form-invalid-feedback v-if="!CTEstate" id="cteInputLiveFeedback">
              Obrigatório. Permitidos apenas números e valores positivos.
            </b-form-invalid-feedback>
          </div>
        </b-form>
      </div>
      <b-modal
         ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2">
        <b-btn size="sm" variant="outline-secondary" @click="$emit('close-form')" class="mr-1 ml-2"> Fechar </b-btn>
        <b-btn  variant="3v3" @click="checkForm" size="sm" class="ml-1 mr-2"> Salvar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  notEmpty,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
export default {
  name: "hydro-model-form",
  props: {
    showForm: Boolean,
    equipment: String,
    oldName: String,
    formType: String,
    alreadyUsedNames: Array,
    itemToEdit: [Number, Object],
  },
  data() {
    return {
      errors: [],
      form: {
        NOME: "",
        MAKER: "",
        CTE: null,
      },
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.form.ID = this.itemToEdit.ID; //IMPORTANTE PARA DIFERENCIAR EDIÇÃO DE ADIÇÃO
          this.form.LAST_NAME = this.itemToEdit.NAME;
          this.form.NAME = this.itemToEdit.NAME;
          this.form.MAKER = this.itemToEdit.MAKER;
          this.form.CTE = this.itemToEdit.CTE;
        }
      }
    },
  },
  computed: {
    nameState() {
      return !!this.form.NAME;
    },
    CTEstate() {
      return /^[.0-9]*$/.test(this.form.CTE);
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
  },
  methods: {
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.form = {
        NAME: "",
        MAKER: "",
        CTE: null,
      };
    },
    checkForm() {
      this.errors = [];
      let states = [this.nameState, this.notRepeatedName, this.CTEstate];
      let erros = [
        "Nome é obrigatório.",
        "Nome escolhido já está em uso. Verifique.",
        "CTE obrigatório. Permitidos apenas números e valores positivos.",
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.$emit("submit", this.form);
        this.$emit("close-form");
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .container-form{
    padding-bottom: 3em;
    padding-left: 0em;
    padding-right: 0;
    margin-right: 0;
  }
  #form, #details {
    padding-top: 1em;
    /* padding-top: 80px; */
}
}
</style>
